import { Component } from '@angular/core';

@Component({
    selector: 'app-planung-api',
    templateUrl: './planung-api.component.html',
    styleUrls: ['./planung-api.component.scss'],
    standalone: false
})
export class PlanungAPIComponent { }
